import React from 'react';
import { ICalendarKeys, CalendarsWidget } from '@benzinga/calendars';
import styled from '@benzinga/themetron';

interface CalendarsBlockProps {
  attrs?: {
    data: {
      tickers: string[];
      initial_tab?: ICalendarKeys;
      title?: string;
      show_logos?: boolean;
      show_title?: boolean;
    };
  };
}

export const CalendarsWidgetBlock: React.FC<CalendarsBlockProps> = ({ attrs }) => {
  const tickers = attrs?.data?.tickers;
  const initialTab = attrs?.data?.initial_tab;
  const title = attrs?.data?.title;
  const showTitle = attrs?.data?.show_title;
  const showLogos = attrs?.data?.show_logos;
  return (
    <Container className="calendars-widget-block">
      <React.Suspense>
        <CalendarsWidget
          initialTab={initialTab}
          initialTickers={tickers}
          injectTickersLogos={showLogos}
          title={title}
          visibleTitle={showTitle}
        />
      </React.Suspense>
    </Container>
  );
};

const Container = styled.div`
  &.calendars-widget-block {
    margin: 1rem auto;
  }
`;
